import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'localization';
import { LDUsers } from 'types';

import { LDList } from './components';

type LDTabProps = { lds: LDUsers; symbol: string | undefined };

const LDTab: React.FC<LDTabProps> = ({ lds, symbol }) => {
  const { t } = useTranslation('component.deposit.ld');

  return (
    <Box w="100%">
      <Text
        fontSize={{ base: 'md', lg: '2xl' }}
        py={2}
        fontWeight="bold"
        color="body"
        mb={{ base: 2, md: 4 }}
      >
        {t('title')}
      </Text>
      <VStack
        display="flex"
        w="100%"
        gap={{ base: 6, md: 8 }}
        align="flex-start"
      >
        <LDList lds={lds} symbol={symbol} />
      </VStack>
    </Box>
  );
};

export default LDTab;
